// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const carApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/offer-tracker/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
    }),
    uploadCarData: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/car",
        method: "POST",
        body: { ...data },
      }),
    }),

    deleteOfferData: builder.mutation({
      query: () => ({
        url: "/api/v1/admin/offer-tracker/remove",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetOffersQuery,
  useUploadCarDataMutation,
  useDeleteOfferDataMutation,
} = carApiSlice;
